import React from "react";

import { Card, Row, Col, Container } from "react-bootstrap";

import SocialMediaIcons from "../utilities/SocialMediaIcons.jsx";

const styles = {
  ul: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "center",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    overflowX: "hidden",
    marginBottom: "3rem",
  },
};

function CooperatorsSpirituality() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Card className="text-center p-md-3 border-0">
        <Card.Title
          className="text-maroon font-header py-5 h1"
          style={{ fontSize: 30 }}
        >
          Spirituality
        </Card.Title>

        <Card.Body
          className="text-start"
          style={{ maxWidth: 1120 + `px`, margin: 0 + ` auto`, fontSize: 15 }}
        >
          <Card.Text style={{ lineHeight: 1.5 }}>
            The Pauline Spirituality is centred on the Word of God and on the
            Eucharist. In our daily contact with God in prayer, we are
            transformed more and more into true disciples and apostles of Jesus.
            By belonging to the Pauline Family we also benefit of the
            supernatural wealth which are in it.
          </Card.Text>
          <Card.Text style={{ lineHeight: 1.5 }}>
            St. Paul, the Apostle of universality, is the inspiration of our
            project of life. He is our model, our guide in living our intimacy
            with Jesus our Master Way, Truth and Life and in reaching out to all
            people with the strength and passion of his heart and the creative
            dynamism of his apostolic zeal and vision.
          </Card.Text>
          <Card.Text style={{ lineHeight: 1.5 }}>
            Mary, Queen of Apostles, who gave Jesus to the world and sustained
            the first apostolic community, is the mother of the Church and of
            the apostles of all times. She teaches us how to give Jesus to
            others through the witness of our lives and our apostolic
            activities.
          </Card.Text>
          <Card.Text style={{ lineHeight: 1.5 }}>
            We trust in the promise Jesus made to our Founder and to the Pauline
            Family:
            <figure
              className="text-start"
              style={{ width: "55%" }}
            >
              <blockquote
                className="blockquote"
                style={{ fontSize: 15 }}
              >
                <p>
                  "Do not be afraid I am with you. From here I want to
                  enlighten. Live in continual conversion".
                </p>
              </blockquote>
              <figcaption className="blockquote-footer">
                J. Alberione
              </figcaption>
            </figure>
          </Card.Text>
          <Row
            xs={1}
            md={3}
            className="g-4"
          >
            <Col>
              <Card
                style={{ minHeight: "600px", display: "flex" }}
                className="bg-light bg-image-1 bg-image"
              >
                <Card.Text className="p-3">
                  Jesus Master, sanctify my mind and increase my faith. Jesus,
                  teaching in the Church, draw everyone to your school. Jesus
                  Master, deliver me from error, form vain thoughts, and from
                  eternal darkness. Jesus, Way between the Father and us, I
                  offer you all and await all from you. Jesus, Way of sanctity,
                  make me your faithful imitator. Jesus Way, render me perfects
                  as the Father who is in heaven. Jesus Life, live in me, so
                  that I my live in you Jesus Life, do not permit me to separate
                  myself from you. Jesus Life, grant that I may live eternally
                  in the joy of your love. Jesus Truth, may I be light for the
                  world. Jesus Way, may I be example and mode for souls. Jesus
                  Life, may my presence bring grace and consolation everywhere.
                </Card.Text>
              </Card>
            </Col>

            <Col>
              <Card
                style={{ minHeight: "600px", display: "flex" }}
                className="bg-light bg-image-2 bg-image"
              >
                <Card.Text className="p-3">
                  I thank you, merciful Jesus, for having given us Mary as our
                  Mother. And I thank you, Mary, for having given to the world
                  the Divine Master, Jesus, Way and Truth and Life, and for
                  having accepted us all as your children on Calvary. Your
                  mission is united to that of Jesus, who “came to seek those
                  who lost.” Therefore, oppressed by my sins, faults, and
                  negligence, I hope. Turn your eyes of mercy toward me. Bestow
                  your most maternal care upon this your most needy child. I
                  place all my trust in you for pardon, conversion and sanctity.
                  Form a new class among your children, that of the most needy:
                  those in whom sin has taken root, where formerly there
                  abounded grace. This will be the class that will most move you
                  to pity. Receive my poor soul into this class. Work a great
                  wonder by changing a great sinner into an apostle. It will be
                  an unheard of wonder, and a new glory for your Son, Jesus; and
                  for you, his and my Mother.
                </Card.Text>
              </Card>
            </Col>
            <Col>
              <Card
                style={{ minHeight: "600px", display: "flex" }}
                className="bg-light bg-image-3 bg-image"
              >
                <Card.Text className="p-3">
                  Holy Apostle who, with your teachings and with your charity,
                  have taught the entire world, look kindly upon us, your
                  children and disciples. We expect everything from your prayers
                  to the Divine Master and Mary, Queen of the Apostle. Grant,
                  Doctor of the Gentiles, that we may live by faith, save
                  ourselves by hope, and that charity alone reign in us. Obtain
                  for us, vessel of election, docile correspondence to divine
                  grace, so that it may not remain unfruitful in us. Grant that
                  we may ever better know you, love you, and imitate you; that
                  we may be living members of the Church, the Mystical Body of
                  Jesus Christ. Raise up many and holy apostles. May the warm
                  breath of true charity permeate the entire world. Grant that
                  all may know and glorify God and the Divine Master, Way and
                  Truth and Life. And, Lord Jesus, you know we have no faith in
                  our own powers. In your mercy grant that we may be defended
                  against all adversity, through the powerful intercession of
                  St. Paul, our Teacher and Father.
                </Card.Text>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <div
        className="divider"
        style={{ borderBottom: "none", maxWidth: "25rem", margin: "2rem auto" }}
      >
        <h1 style={{ display: "block", margin: "1rem auto", color: "#005ca9" }} className="text-start">
          Connect with us
        </h1>
      </div>

      <Container>
        <SocialMediaIcons
          fonts="black"
          display={styles.ul}
        />
      </Container>
    </>
  );
}

export default CooperatorsSpirituality;
